
export class GSTLocationModel {
    locationId:number;
    locationName?:string;
    gstNumber?: string;
    operatorId?:number;
    generationTime?:Date;
    gstAddress?:string;
    gstName?:string;
}
